import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { TranslocoDirective } from '@jsverse/transloco';

@Component({
  selector: 'shared-echarts-empty',
  imports: [TranslocoDirective],
  templateUrl: './empty-echarts.component.html',
  styleUrl: './empty-echarts.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EmptyEchartsComponent {
  readonly hasBorderIfNoData = input(false);
}
